import React, { Component } from "react";

class ERCP extends Component {
    render() {
      return (
        <>
        <h4>ERCP</h4>
          <div className="video-container">
          <iframe width="853" title="ercp video" height="480" src="https://www.youtube.com/embed/5I504enWYCY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <p>Endoscopic retrograde
          cholangiopancreatography
          (en-doh-SKAH-pik REH-troh-grayd
          koh-LAN-jee-oh-PANG-kree-uh-TAH-gruh-fee)
          (ERCP) enables the physician to
          diagnose problems in the liver,
          gallbladder, bile ducts, and pancreas.
          The liver is a large organ that, among
          other things, makes a liquid called bile
          that helps with digestion. The gallbladder
          is a small, pear-shaped organ that stores
          bile until it is needed for digestion. The
          bile ducts are tubes that carry bile from
          the liver to the gallbladder and small
          intestine. These ducts are sometimes
          called the biliary tree. The pancreas is a
          large gland that produces chemicals that
          help with digestion and hormones such
          as insulin.</p>

          <p>ERCP is used primarily to diagnose and
          treat conditions of the bile ducts
          including gallstones, inflammatory
          strictures (scars), leaks(from trauma and
          surgery), and cancer. ERCP combines
          the use of x rays and an endoscope,
          which is a long, flexible, lighted tube.
          Through it, the physician can see the
          inside of the stomach and duodenum,
          and inject dyes into the ducts in the
          biliary tree and pancreas so they can be
          seen on x rays.</p>

          <p>For the procedure, you will lie on your
          left side on an examining table in an x ray
          room. You will be given medication to	
          help numb the back of your throat and a sedative to help you relax during the exam. You
          will swallow the endoscope, and the physician will then guide the scope through your
          esophagus, stomach, and duodenum until it reaches the spot where the ducts of the biliary
          tree and pancreas open into the duodenum. At this time, you will be turned to lie flat on
          your stomach, and the physician will pass a small plastic tube through the scope. Through
          the tube, the physician will inject a dye into the ducts to make them show up clearly on x
          rays. X rays are taken as soon as the dye is injected.</p>

          <p>If the exam shows a gallstone or narrowing of the ducts, the physician can insert
          instruments into the scope to remove or relieve the obstruction. Also, tissue samples
          (biopsy) can be taken for further testing.</p>

          <p>Possible complications of ERCP include pancreatitis (inflammation of the pancreas),
          infection, bleeding, and perforation of the duodenum. Except for pancreatitis, such
          problems are uncommon. You may have tenderness or a lump where the sedative was
          injected, but that should go away in a few days.</p>

          <p>ERCP takes 30 minutes to 2 hours. You may have some discomfort when the physician
          blows air into the duodenum and injects the dye into the ducts. However, the pain
          medicine and sedative should keep you from feeling too much discomfort. After the
          procedure, you will need to stay at the hospital for 1 to 2 hours until the sedative wears
          off. The physician will make sure you do not have signs of complications before you
          leave. If any kind of treatment is done during ERCP, such as removing a gallstone, you
          may need to stay in the hospital overnight.</p>

          <h5>Preparation</h5>

          <p>Your stomach and duodenum must be empty for the procedure to be accurate and safe.
          You will not be able to eat or drink anything after midnight the night before the procedure,
          or for 6 to 8 hours beforehand, depending on the time of your procedure. Also, the
          physician will need to know whether you have any allergies, especially to iodine, which is
          in the dye. You must also arrange for someone to take you home--you will not be allowed
          to drive because of the sedatives. The physician may give you other special instructions.</p>
        </>
      );
    }
  }
   
  export default ERCP;